// TUT-517 — o `validateSearch` de `/notificacoes`, em arquivo próprio pelo
// mesmo motivo do de `/normas`: a central não é lista de cadastro (não ordena
// no servidor, não tem colunas a escolher), e pôr o helper em `buscas.ts` a
// faria entrar no censo de `list-route-contract.test.ts` por acidente.
import { texto } from "./buscas";

/**
 * A aba (`todas`; "Não lidas" é o padrão, e o padrão é a ausência da chave), a
 * busca, o Tipo (o módulo do catálogo), o Período (TUT-586a: hoje ou os
 * últimos 7 dias; qualquer data é a ausência) e o aviso aberto no detalhe.
 */
export type NotificacoesSearch = {
  /** TUT-586b — e as caixas Adiadas e Arquivadas. */
  filtro?: "todas" | "adiadas" | "arquivadas";
  q?: string;
  modulo?: string;
  periodo?: "hoje" | "semana";
  id?: string;
};

export function validarBuscaDeNotificacoes(busca: Record<string, unknown>): NotificacoesSearch {
  const { filtro, q, modulo, periodo, id, ...resto } = busca;
  return {
    ...resto,
    filtro: filtro === "todas" || filtro === "adiadas" || filtro === "arquivadas" ? filtro : undefined,
    periodo: periodo === "hoje" || periodo === "semana" ? periodo : undefined,
    q: texto(q),
    modulo: texto(modulo),
    id: texto(id),
  } as NotificacoesSearch;
}
